import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { Form, FormGroup, Row, Col, Card, CardBody, Container } from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import { formatBytes } from '../../Common';
import { getSingleCategory, updateCategoryData } from '../../API/Backend';
import { showToast } from "../../Components/Toast"
import noImage from "../../Assets/images/no-image.jpg"

const EditCategory = () => {
    const params = useParams();
    const id = params.id;
    const history = useNavigate();
    const [categoryFile, setCategoryFile] = useState(null);
    //   const [previewUrl, setPreviewUrl] = useState('https://images.unsplash.com/photo-1506744038136-46273834b3fb');
    const [previewUrl, setPreviewUrl] = useState(noImage);
    const [errors, setErrors] = useState({ categoryFile: "", previewUrl: "" });
    const [loading, setLoading] = useState(false);
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
    const ALLOWED_FORMATS = ['jpg', 'jpeg', 'png'];

    useEffect(() => {
        fetchSingleCategory();
    }, []);

    const fetchSingleCategory = () => {
        setLoading(true)
        getSingleCategory(id).then(({ data }) => {
            if (data.data) {
                setPreviewUrl(data.data.image ? `${process.env.REACT_APP_IMAGE_DIRECTORY}/category/${data.data.image}` : noImage)
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
            setLoading(false)
        })
    }

    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];

        setErrors({ categoryFile: "", previewUrl: "" });

        if (!file) {
            setErrors({ categoryFile: "No file selected." });
            setCategoryFile(null);
            setPreviewUrl(null);
            return;
        }

        const fileExt = file.name.split('.').pop().toLowerCase();
        if (!ALLOWED_FORMATS.includes(fileExt)) {
            setErrors({ categoryFile: "Only jpg, jpeg, png files are allowed." });
            setCategoryFile(null);
            setPreviewUrl(null);
            return;
        }

        if (file.size > MAX_FILE_SIZE) {
            setErrors({ categoryFile: "File size should be less than 5MB." });
            setCategoryFile(null);
            setPreviewUrl(null);
            return;
        }

        const formattedFiles = [file].map(f =>
            Object.assign(f, {
                formattedSize: formatBytes(f.size),
                preview: URL.createObjectURL(f),
            })
        );

        setCategoryFile(formattedFiles[0]);
        setPreviewUrl(formattedFiles[0].preview);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        // accept: {
        //   'image/jpeg': ['.jpeg', '.jpg'],
        //   'image/png': ['.png']
        // },
        multiple: false
    });

    const handleSubmit = (e) => {
        e.preventDefault()
        let flag = false;
        let error = { categoryFile: "" };
        if (!categoryFile) {
            flag = true;
            error.categoryFile = "Please provide a valid file";
        }
        setErrors(error)
        if (!flag) {
            setLoading(true);
            const formData = new FormData();
            if (categoryFile) {
                formData.append("image", categoryFile);
            }
            updateCategoryData(formData, id).then((data) => {
                if (data.data.success) {
                    showToast("success", "Category Updated", "Category has been updated successfully.")
                    setLoading(false);
                    history('/categories')
                }
                else {
                    showToast("error", "Category Request Failed", "Category could not be updated.")
                    setLoading(false);
                }
            }).catch((e) => {
                showToast("error", "Category Request Failed", "Category could not be updated.")
                setLoading(false);
            })
        }
    };

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h4 className="fw-600 fs-18 mb-4">Edit Category</h4>
                    <Card className='pt-2'>
                        <CardBody>
                            <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                    <div
                                        {...getRootProps()}
                                        className="text-center my-4 border p-2 rounded"
                                        style={{
                                            borderStyle: 'dashed',
                                            cursor: 'pointer',
                                            backgroundColor: '#f9f9f9'
                                        }}
                                    >
                                        <input {...getInputProps()} />
                                        {previewUrl ? (
                                            <img
                                                src={previewUrl}
                                                alt="Preview"
                                                style={{
                                                    width: '100%',
                                                    maxHeight: '200px',
                                                    objectFit: 'cover',
                                                    borderRadius: '6px',
                                                }}
                                            />
                                        ) : (
                                            <div>
                                                <img src={previewUrl} alt="Upload Icon" />
                                                <p className="fs-14 fw-400">
                                                    {isDragActive ? 'Drop the image here...' : 'Upload Banner'}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                    {errors.categoryFile && <div className="text-danger fs-12">{errors.categoryFile}</div>}
                                </FormGroup>

                                <FormGroup className='text-end'>
                                    <button disabled={loading} className='btn btn-primary' type="submit">{loading ? 'Please Wait' : 'Update'}</button>
                                </FormGroup>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
export default EditCategory